"use client"

import ToFAQ from "@/components/Category/ToFAQ";
import CTA from "@/components/CTA";
import { site } from "@/data/default";
import { ReactNode } from "react";

const laptopBekasi: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-4">Kenapa Sewa Laptop Bekasi & Sekitarnya Lebih Masuk Akal Daripada Beli</h2>

    <p className="mb-4">
      Dalam ritme industri dan urban seperti Bekasi, <strong>sewa laptop Bekasi</strong> bukan sekadar alternatif, ini murni strategi efisiensi. Saat kebutuhan datang tiba² dan anggaran harus dijaga, <strong>sewa laptop Bekasi</strong> jadi solusi paling masuk akal: fleksibel, praktis, dan bebas repot.
    </p>

    <div className="grid gap-6">
      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Jangkauan Luas: Bekasi Kota hingga Kawasan Industri</h3>
        <p>
          Layanan <strong>sewa laptop Bekasi</strong> kami mencakup area seperti Tambun, Kranji, Cibitung, Jatiasih, Harapan Indah, Galaxy, Jatibening, Mustikajaya, hingga kawasan industri strategis seperti MM2100, Jababeka, Delta Silicon, dan Lippo Cikarang. Tinggal pilih spek, kami antar.
        </p>
      </div>

      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Laptop Ready Pakai: Bersih, Update & Stabil</h3>
        <p>
          Setiap unit <strong>laptop sewaan Bekasi</strong> kami sudah preload software standar, OS terupdate, dan maintenance rutin. Laptop error? Kami ganti. Kamu cukup fokus kerja, teknis biar kami yang urus.
        </p>
      </div>

      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Gratis Ongkir Bekasi² & Sekitarnya</h3>
        <p>
          Pengiriman <strong>sewa laptop Bekasi</strong> GRATIS ke semua titik—mulai dari perumahan di Summarecon, kampus di Harapan Baru, hingga kawasan industri di Cikarang dan Cibitung. Tanpa minimum, tanpa delay.
        </p>
      </div>

      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Support 24 Jam</h3>
        <p>
          Kota Bekasi dan kawasan industrinya tak pernah benar² tidur. Maka kami juga begitu. Tim support <strong>sewa laptop Bekasi</strong> standby 24/7. Urusan teknis? Kami datang ke lokasi kamu, kapan pun.
        </p>
      </div>

      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Harga Nego, Spek Laptop Bisa Custom</h3>
        <p>
          Butuh laptop Core i5, i7, RAM besar, SSD cepat, atau GPU kuat? Untuk desain grafis, editing, pelatihan massal, atau keperluan kantor?
          Kami sesuaikan. Harga <strong>sewa laptop Bekasi</strong> fleksibel, tanpa biaya tersembunyi.
        </p>
      </div>
    </div>

    <h2 className="text-xl font-bold mt-8 mb-3">Jemput Antar Langsung ke Lokasimu</h2>
    <p className="mb-4">
      Mau sewa dari rumah cluster di Grand Wisata, pabrik di MM2100, sekolah di Tambun, atau toko di Cikarang? Kami handle semua logistiknya. <strong>Sewa laptop Bekasi</strong> makin simpel karena kamu nggak perlu ke mana².
    </p>

    <h2 className="text-xl font-bold mb-3">Durasi Fleksibel: Harian², Mingguan², Bulanan²</h2>
    <p className="mb-4">
      Trial 1 hari? Event seminggu? Proyek 3 bulan? Sistem <strong>sewa laptop Bekasi</strong> kami fleksibel dan bisa diperpanjang sesuai kebutuhan. Tanpa kontrak ribet.
    </p>

    <h2 className="text-xl font-bold mb-3">Backup Unit & Garansi Sepanjang Masa Sewa</h2>
    <p className="mb-4">
      Setiap unit kami cover dengan backup cadangan. Gangguan teknis? Kami langsung ganti. Kamu nggak akan ditinggal. <strong>Sewa laptop Bekasi</strong> yang siap bantu kapan pun kamu butuh.
    </p>

    <CTA
      title="Siap Kerja Editing & Olah Data Dimana² Bosku?"
      description="🚚 Butuh sewa laptop terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Laptop Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20laptop.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Laptop"
    />
  </>
);

export default laptopBekasi;